import {
  Box,
  Button,
  TextField,
  Typography,
  Card,
  CardContent,
} from "@mui/material";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { enqueueSnackbar } from "notistack";
import forgotPassword from "@/services/auth/forgot";
import { useNavigate } from "react-router-dom";
import { YELLOW_COLOR } from "@/constants/color";

const schema = yup.object({
  email: yup.string().email("Correo inválido").required("Campo requerido"),
});

type FormData = yup.InferType<typeof schema>;

export default function ForgotPassword() {
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<FormData>({ resolver: yupResolver(schema) });

  const onSubmit = async (data: FormData) => {
    try {
      await forgotPassword(data.email);
      enqueueSnackbar("Revisa tu correo para restablecer tu contraseña", {
        variant: "success",
        onClose: () => {
          navigate(-1);
        },
      });
    } catch (error) {
      console.error(error);
      enqueueSnackbar("Error de red", { variant: "error" });
    }
  };

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
      p={2}
    >
      <Card
        sx={{
          p: 4,
          width: "100%",
          maxWidth: 400,
          boxShadow: 10,
          backgroundColor: "rgba(255, 255, 255, 0.03)",
          backdropFilter: "blur(7px)",
        }}
      >
        <CardContent>
          <Typography
            variant="h5"
            fontWeight="bold"
            gutterBottom
            sx={{ color: "#e3e3e3" }}
          >
            ¿Olvidaste tu contraseña?
          </Typography>
          <Typography variant="body2" sx={{ color: "#e3e3e3" }} gutterBottom>
            Ingresa tu correo y te enviaremos un enlace para restablecerla.
          </Typography>

          <Box component="form" onSubmit={handleSubmit(onSubmit)} mt={2}>
            <TextField
              label="Correo electrónico"
              fullWidth
              {...register("email")}
              error={!!errors.email}
              helperText={errors.email?.message}
              margin="normal"
              InputLabelProps={{
                style: { color: "#e3e3e3" },
              }}
              InputProps={{
                style: { color: "#e3e3e3" },
              }}
              sx={{
                "& .MuiOutlinedInput-root": {
                  "& fieldset": { borderColor: "#e3e3e3" },
                  "&:hover fieldset": { borderColor: "#e3e3e3" },
                  "&.Mui-focused fieldset": { borderColor: "#e3e3e3" },
                },
              }}
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 2, backgroundColor: YELLOW_COLOR }}
            >
              Enviar enlace
            </Button>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
}
